import react, { Fragment, useState, useEffect } from 'react'

import axios from 'axios'
import { toast } from 'react-toastify'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Container from 'react-bootstrap/Container'
import { Form } from 'react-bootstrap'
import {} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import loadingImg from '../../Assets/loading.gif'
import { AiOutlineLogout } from 'react-icons/ai'
import logo1 from '../../StudentRegristrationDesign/jain logo.png'
import { Button, DatePicker } from 'antd'
import moment from 'moment'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DemoContainer } from '@mui/x-date-pickers/internals/demo'
import dayjs from 'dayjs'
import {
  AluminiAdd,
  AluminiDistrictFind,
  AluminiStateFindAll,
  AluminiTalukaFind,
} from '../../ApiFile'
import { ThreeDots } from 'react-loader-spinner'

function Aluminiform() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const currentYear = new Date().getFullYear()
  const [yearFrom, setYearFrom] = useState(currentYear.toString())
  const [yearTo, setYearTo] = useState(currentYear.toString())

  const handleChangeFrom = (e) => {
    setYearFrom(e.target.value)
  }
  const handleChangeTo = (e) => {
    setYearTo(e.target.value)
  }

  const userdata = JSON.parse(sessionStorage.getItem('userdata'))
  const email_id = userdata.email_id
  const f_name = userdata.f_name
  const m_name = userdata.m_name
  const l_name = userdata.l_name

  const [stateList, setStateList] = useState([])
  const [districtList, setDistrictList] = useState([])
  const [talukaList, setTalukaList] = useState([])
  const [pDistrictList, setPDistrictList] = useState([]) // new state for permanent address district list
  const [pTalukaList, setPTalukaList] = useState([]) // new state for permanent address taluka list

  const [selectedState, setSelectedState] = useState('')
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [selectedTaluka, setSelectedTaluka] = useState('')
  const [pSelectedState, setPSelectedState] = useState('')
  const [pSelectedDistrict, setPSelectedDistrict] = useState('')
  const [pSelectedTaluka, setPSelectedTaluka] = useState('')
  const [fileName, setFileName] = useState('')

  const [currentAddress, setCurrentAddress] = useState('')
  const [currentPincode, setCurrentPincode] = useState('')
  const [permanentAddress, setPermanentAddress] = useState('')
  const [permanentPincode, setPermanentPincode] = useState('')

  const [blood_group, setblood_group] = useState('')
  const [qualification, setqualification] = useState('')
  const [dateofbirth, setdateofbirth] = useState('')
  const [date, setDate] = useState(null)
  const [mob_no, setmob_no] = useState('')
  const [alternate_mobno, setalternate_mobno] = useState('')
  const [professional_category, setprofessional_category] = useState('')
  const [service_name, setservice_name] = useState('')
  const [reference_fname, setreference_fname] = useState('')
  const [reference_mname, setreference_mname] = useState('')
  const [reference_lname, setreference_lname] = useState('')
  const [contactdetails, setcontactdetails] = useState('')
  const [achievements, setachievements] = useState('')
  const [comment, setcomment] = useState('')
  const [file, setfile] = useState(null)

  useEffect(() => {
    axios
      .get(AluminiStateFindAll)
      .then((response) => {
        setStateList(response.data)
      })
      .catch((error) => {
        // console.error('Error fetching states:', error);
      })
  }, [])

  useEffect(() => {
    if (selectedState !== '') {
      axios
        .get(`${AluminiDistrictFind}/${selectedState}`)
        .then((response) => {
          setDistrictList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching districts:', error);
        })
    }
  }, [selectedState])

  useEffect(() => {
    if (selectedState !== '' && selectedDistrict !== '') {
      axios
        .get(`${AluminiTalukaFind}/${selectedState}/${selectedDistrict}`)
        .then((response) => {
          setTalukaList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching talukas:', error);
        })
    }
  }, [selectedState, selectedDistrict])

  useEffect(() => {
    if (pSelectedState !== '') {
      axios
        .get(`${AluminiDistrictFind}/${pSelectedState}`)
        .then((response) => {
          setPDistrictList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching permanent address districts:', error);
        })
    }
  }, [pSelectedState])

  useEffect(() => {
    if (pSelectedState !== '' && pSelectedDistrict !== '') {
      axios
        .get(`${AluminiTalukaFind}/${pSelectedState}/${pSelectedDistrict}`)
        .then((response) => {
          setPTalukaList(response.data)
        })
        .catch((error) => {
          // console.error('Error fetching permanent address talukas:', error);
        })
    }
  }, [pSelectedState, pSelectedDistrict])

  const handleStateChange = (e) => {
    setSelectedState(e.target.value)
    setSelectedDistrict('')
    setSelectedTaluka('')
  }

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value)
    setSelectedTaluka('')
  }

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value)
  }

  const handlePStateChange = (e) => {
    setPSelectedState(e.target.value)
    setPSelectedDistrict('')
    setPSelectedTaluka('')
  }

  const handlePDistrictChange = (e) => {
    setPSelectedDistrict(e.target.value)
    setPSelectedTaluka('')
  }

  const handlePTalukaChange = (e) => {
    setPSelectedTaluka(e.target.value)
  }
  const [responseMessage, setResponseMessage] = useState('')

  //checkbox
  const [usePermanentAddress, setUsePermanentAddress] = useState(false)
  const handleUsePermanentAddressChange = (e) => {
    setUsePermanentAddress(e.target.checked)
    if (e.target.checked) {
      setPSelectedState(selectedState)
      setPSelectedDistrict(selectedDistrict)
      setPSelectedTaluka(selectedTaluka)
      setPermanentAddress(currentAddress)
      setPermanentPincode(currentPincode)
    } else {
      setPSelectedState('')
      setPSelectedDistrict('')
      setPSelectedTaluka('')
      setPermanentAddress('')
      setPermanentPincode('')
    }
  }

  const handleCurrentAddressChange = (event) => {
    setCurrentAddress(event.target.value)
  }

  const handleCurrentPincodeChange = (e) => {
    // setCurrentPincode(event.target.value);
    const input = e.target.value
    if (/^\d*$/.test(input) && input.length <= 6) {
      // Update state only if the input is a number and within the length limit
      setCurrentPincode(input)
    }
  }

  const [errors, setErrors] = useState({})

  // Validation functions
  const validateMobileNumber = (number) => /^[0-9]{10}$/.test(number)
  const validatePincode = (pincode) => /^[0-9]{6}$/.test(pincode)

  //add api
  // const handleSubmit = async (event) => {
  //   event.preventDefault()
  //   const formattedDate = date ? dayjs(date).format('DD/MM/YYYY') : null

  //   // List of required fields


  //     const requiredFields = [
  //   { value: file, name: 'Photo' },
  //   { value: f_name, name: 'First Name' },
  //   { value: m_name, name: 'Middle Name' },
  //   { value: l_name, name: 'Last Name' },
  //   { value: qualification, name: 'Qualification' },
  //   { value: currentAddress, name: 'Current Address' },
  //   { value: currentPincode, name: 'Current Pincode' },
  //   { value: selectedState, name: 'State' },
  //   { value: selectedDistrict, name: 'District' },
  //   { value: selectedTaluka, name: 'Taluka' },
  //   { value: permanentAddress, name: 'Permanent Address' },
  //   { value: permanentPincode, name: 'Permanent Pincode' },
  //   { value: pSelectedState, name: 'Permanent State' },
  //   { value: pSelectedDistrict, name: 'Permanent District' },
  //   { value: pSelectedTaluka, name: 'Permanent Taluka' },
  //   { value: formattedDate, name: 'Date of Birth' },
  //   { value: blood_group, name: 'Blood Group' },
  //   { value: email_id, name: 'Email' },
  //   { value: mob_no, name: 'Mobile Number' },
  //   { value: alternate_mobno, name: 'Alternate Mobile Number' },
  //   { value: professional_category, name: 'Professional Category' },
  //   { value: service_name, name: 'Service Name' },
  //   { value: yearFrom, name: 'From Year' },
  //   { value: yearTo, name: 'To Year' },
  //   // { value: reference_fname, name: "Reference Partner's First Name" },
  //   // { value: reference_mname, name: "Reference Partner's Middle Name" },
  //   // { value: reference_lname, name: "Reference Partner's Last Name" },
  //   // { value: contactdetails, name: "Partner's Contact" },
  //   // { value: achievements, name: 'Special Achievements' },
  //   { value: comment, name: 'Comments/Suggestions' },
  // ]

  //   // Check for any empty required fields
  //   const missingField = requiredFields.find((field) => !field.value)

  //   if (missingField) {
  //     toast.error(`${missingField.name} is required`)
  //     return
  //   }

  //   const formData = new FormData()

  //   try {
  //     formData.append('profile_img', file)
  //     formData.append('fname', f_name)
  //     formData.append('mname', m_name)
  //     formData.append('lname', l_name)
  //     formData.append('qualification', qualification)
  //     formData.append('address', currentAddress)
  //     formData.append('pincode', currentPincode)
  //     formData.append('state', selectedState)
  //     formData.append('district', selectedDistrict)
  //     formData.append('taluka', selectedTaluka)
  //     formData.append('alternate_address', permanentAddress)
  //     formData.append('alternate_pincode', permanentPincode)
  //     formData.append('alternate_state', pSelectedState)
  //     formData.append('alternate_district', pSelectedDistrict)
  //     formData.append('alternate_taluka', pSelectedTaluka)
  //     formData.append('dateofbirth', formattedDate)
  //     formData.append('blood_group', blood_group)
  //     formData.append('email_id', email_id)
  //     formData.append('mob_no', mob_no)
  //     formData.append('alternate_mobno', alternate_mobno)
  //     formData.append('professional_category', professional_category)
  //     formData.append('service_name', service_name)
  //     formData.append('fromyear', yearFrom)
  //     formData.append('toyear', yearTo)
  //     formData.append('reference_fname', reference_fname)
  //     formData.append('reference_mname', reference_mname)
  //     formData.append('reference_lname', reference_lname)
  //     formData.append('contactdetails', contactdetails)
  //     formData.append('achievements', achievements)
  //     formData.append('comment', comment)

  //     // Validation code here...
  //     setLoading(true);
  //     const response = await axios.post(AluminiAdd, formData)
  //     if (response.data == 'Failed to upload file') {
  //       toast.error('Failed to upload Alumni data!')
  //     } else if (response.data.message == 'SAVED') {
  //       toast.success('Alumni data added successfully!')
  //       navigate('/AluminiDashboard')
  //     }
  //   } catch (error) {
  //     console.error('Error occurred while submitting the form:', error)
  //   }
  // }

   const handleSubmit = async (event) => {
    event.preventDefault();
    const formattedDate = date ? dayjs(date).format("DD/MM/YYYY") : null;

    const requiredFields = [
      { value: file, name: "Photo" },
      { value: f_name, name: "First Name" },
      { value: m_name, name: "Middle Name" },
      { value: l_name, name: "Last Name" },
      { value: qualification, name: "Qualification" },
      { value: currentAddress, name: "Current Address" },
      { value: currentPincode, name: "Current Pincode" },
      { value: selectedState, name: "State" },
      { value: selectedDistrict, name: "District" },
      { value: selectedTaluka, name: "Taluka" },
      { value: permanentAddress, name: "Permanent Address" },
      { value: permanentPincode, name: "Permanent Pincode" },
      { value: pSelectedState, name: "Permanent State" },
      { value: pSelectedDistrict, name: "Permanent District" },
      { value: pSelectedTaluka, name: "Permanent Taluka" },
      { value: formattedDate, name: "Date of Birth" },
      { value: blood_group, name: "Blood Group" },
      { value: email_id, name: "Email" },
      { value: mob_no, name: "Mobile Number" },
      { value: alternate_mobno, name: "Alternate Mobile Number" },
      { value: professional_category, name: "Professional Category" },
      { value: service_name, name: "Service Name" },
      { value: yearFrom, name: "From Year" },
      { value: yearTo, name: "To Year" },
      { value: comment, name: "Comments/Suggestions" },
    ];

    const missingField = requiredFields.find((field) => !field.value);
    if (missingField) {
      toast.error(`${missingField.name} is required`);
      return;
    }

    const formData = new FormData();
    formData.append("profile_img", file);
    formData.append("fname", f_name);
    formData.append("mname", m_name);
    formData.append("lname", l_name);
    formData.append("qualification", qualification);
    formData.append("address", currentAddress);
    formData.append("pincode", currentPincode);
    formData.append("state", selectedState);
    formData.append("district", selectedDistrict);
    formData.append("taluka", selectedTaluka);
    formData.append("alternate_address", permanentAddress);
    formData.append("alternate_pincode", permanentPincode);
    formData.append("alternate_state", pSelectedState);
    formData.append("alternate_district", pSelectedDistrict);
    formData.append("alternate_taluka", pSelectedTaluka);
    formData.append("dateofbirth", formattedDate);
    formData.append("blood_group", blood_group);
    formData.append("email_id", email_id);
    formData.append("mob_no", mob_no);
    formData.append("alternate_mobno", alternate_mobno);
    formData.append("professional_category", professional_category);
    formData.append("service_name", service_name);
    formData.append("fromyear", yearFrom);
    formData.append("toyear", yearTo);
    formData.append("reference_fname", reference_fname);
    formData.append("reference_mname", reference_mname);
    formData.append("reference_lname", reference_lname);
    formData.append("contactdetails", contactdetails);
    formData.append("achievements", achievements);
    formData.append("comment", comment);

    try {
      setLoading(true); // 🔥 show loader
      const response = await axios.post(AluminiAdd, formData);

      if (response.data === "Failed to upload file") {
        toast.error("Failed to upload Alumni data!");
      } else if (response.data.message === "SAVED") {
        toast.success("Alumni data added successfully!");
        navigate("/AluminiDashboard");
      }
    } catch (error) {
      console.error("Error occurred while submitting the form:", error);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false); // 🔥 hide loader
    }
  };


  const logoutFun = () => {
    sessionStorage.removeItem('userdata')
    sessionStorage.clear()
    navigate('/')
  }

  useEffect(() => {
    if (userdata == null) {
      sessionStorage.clear()
      navigate('/AluminiLogin')
    }
  }, [])

  const inputStyle = {
    marginTop: '-9px',
    height: '37px',
  }

  return (
    <>
      <Container className="pb-5">
        <div
          className="shadow"
          style={{
            backgroundColor: '#fff',
            borderRadius: '10px',
            padding: '20px',
            marginTop: '20px',
          }}
        >
          <Row
            className=" py-1 shadow m-0 p-0 "
            style={{
              display: 'flex',
              backgroundColor: '#a2d6f8',
            }}
          >
            <Col sm={12} md={8}>
              <img
                src={logo1}
                alt="Logo"
                style={{ mixBlendMode: 'darken',height:"100px" }}
              />
            </Col>
            <Col sm={12} md={4} className="text-end">
              <p
                style={{ textAlign: 'end', textShadow: '1px 1px 1px' }}
                className="pt-4 pe-4"
              >
                <a className="sidebar-list-link" onClick={logoutFun}>
                  <AiOutlineLogout
                    className="icon"
                    title="Logout"
                    style={{ cursor: 'pointer' }}
                  />
                </a>
              </p>
            </Col>
          </Row>

          <Row className='m-0 px-2 py-3'>
             <h4 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
               Alumni Registration Form
            </h4>
          </Row>
          <Row>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label className='labelText'>Upload Photo</Form.Label>
              <Form.Control
                type="file"
                accept=".png, .jpg, .jpeg"
                   onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (file && file.size > 5 * 1024 * 1024) {
                                      alert("File size should not exceed 5MB");
                                      e.target.value = null; // Reset the file input
                                      return;
                                    }
                                    setfile(file);
                                  }}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Label className='labelText'>Full Name</Form.Label>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridFname">
              <Form.Control
                type="text"
                placeholder="First name"
                required
                value={f_name}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridMname">
              <Form.Control
                type="text"
                placeholder="Middle name"
                required
                value={m_name}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridLname">
              <Form.Control
                type="text"
                placeholder="Last Name"
                required
                value={l_name}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} sm={3} controlId="formFile">
              <Form.Label className='labelText'>Date of Birth</Form.Label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    format="DD-MM-YYYY"
                    className="w-100 rounded"
                    style={inputStyle}
                    required
                    value={date}
                    onChange={(newDate) => setDate(newDate)}
                    slotProps={{ textField: { size: 'small' } }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
              <Form.Label className='labelText'>Blood Group</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                value={blood_group}
                onChange={(e) => setblood_group(e.target.value)}
                required
              >
                <option>Choose...</option>
                <option value="A +ve">A +ve</option>
                <option value="A -ve">A -ve</option>
                <option value="B +ve">B +ve</option>
                <option value="B -ve">B -ve</option>
                <option value="AB +ve">AB +ve</option>
                <option value="AB -ve">AB -ve</option>
                <option value="O +ve">O +ve</option>
                <option value="O -ve">O -ve</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
              <Form.Label className='labelText'>Email</Form.Label>
              <Form.Control
                type="email"
                maxLength={25}
                placeholder=""
                value={email_id}
                required
              />
            </Form.Group>
          </Row>
          <hr style={{ height: '1px' }} />

          <Row className="mb-3">
            <span
              className="m-2 p-0"
              style={{ fontSize: '18px', fontWeight: 'bold',color:"gray" }}
            >
              Current Detail Address
            </span>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridState">
              <Form.Label className='labelText'>State</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="state"
                value={selectedState}
                onChange={handleStateChange}
                required
              >
                <option value="">Choose...</option>
                {stateList.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.state_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridDistrict">
              <Form.Label className='labelText'>District</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="district"
                value={selectedDistrict}
                onChange={handleDistrictChange}
                required
              >
                <option value="">Choose...</option>
                {districtList.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.districtenname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridTaluka">
              <Form.Label className='labelText'>Taluka</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="taluka"
                value={selectedTaluka}
                onChange={handleTalukaChange}
                required
              >
                <option value="">Choose...</option>
                {talukaList.map((taluka) => (
                  <option key={taluka.id} value={taluka.id}>
                    {taluka.talukaenname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
              <Form.Label className='labelText'>Pin code</Form.Label>
              <Form.Control
                type="number"
                placeholder="pincode"
                maxLength={6}
                value={currentPincode}
                onChange={handleCurrentPincodeChange}
                required
              />
              {errors.currentPincode && (
                <p className="text-danger">{errors.currentPincode}</p>
              )}
            </Form.Group>
          </Row>

          <div className="Caddress">
            <Form.Group as={Col} xs={12} controlId="formGridEmail">
              <Form.Label className='labelText'>Detail Address Line</Form.Label>
              <Form.Control
                type="text"
                maxLength={200}
                value={currentAddress}
                onChange={handleCurrentAddressChange}
                placeholder="House Name/No/Road/Chowk/Colony/Landmark/P.O/Village/City"
                required
              />
            </Form.Group>
          </div>
          {/* <hr style={{ height: '1px' }} /> */}
          <Form.Group
            as={Col}
            xs={12}
            className="my-4"
            sm={12}
            controlId="formGridUsePermanentAddress"
          >
            <Form.Check
              type="checkbox"
              label="Use current address as permanent address"
              checked={usePermanentAddress}
              onChange={handleUsePermanentAddressChange}
            />
          </Form.Group>

          <Row className="mb-3">
            <span
              className="m-2 p-0"
              style={{ fontSize: '18px', fontWeight: 'bold',color:"gray" }}
            >
              Permanent Detail Address
            </span>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPState">
              <Form.Label className='labelText'>State</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="alternate_state"
                value={pSelectedState}
                onChange={handlePStateChange}
                required
              >
                <option value="">Choose...</option>
                {stateList.map((state) => (
                  <option key={state.id} value={state.id}>
                    {state.state_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPDistrict">
              <Form.Label className='labelText'>District</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="alternate_district"
                value={pSelectedDistrict}
                onChange={handlePDistrictChange}
                required
              >
                <option value="">Choose...</option>
                {pDistrictList.map((district) => (
                  <option key={district.id} value={district.id}>
                    {district.districtenname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPTaluka">
              <Form.Label className='labelText'>Taluka</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                name="alternate_taluka"
                value={pSelectedTaluka}
                onChange={handlePTalukaChange}
                required
              >
                <option value="">Choose...</option>
                {pTalukaList.map((taluka) => (
                  <option key={taluka.id} value={taluka.id}>
                    {taluka.talukaenname}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={3} controlId="formGridPassword">
              <Form.Label className='labelText'>Pin code</Form.Label>
              <Form.Control
                type="number"
                maxLength={6}
                placeholder=""
                value={permanentPincode}
                //  onChange={(e) => setPermanentPincode(e.target.value)}
                onChange={(e) => {
                  const input = e.target.value
                  // Check if the input consists only of numbers and has a maximum length of 6
                  if (/^\d*$/.test(input) && input.length <= 6) {
                    // Update state only if the input is a number and within the length limit
                    setPermanentPincode(input)
                  }
                }}
                required
              />
              {errors.permanentPincode && (
                <p className="text-danger">{errors.permanentPincode}</p>
              )}
            </Form.Group>
          </Row>

          <div className="Paddress">
            <Form.Group as={Col} xs={12} controlId="formGridEmail">
              <Form.Label className="pt-3 labelText">Detail Address Line</Form.Label>
              <Form.Control
                type="text"
                placeholder="House Name/No/Road/Chowk/Colony/Landmark/P.O/Village/City"
                value={permanentAddress}
                onChange={(e) => setPermanentAddress(e.target.value)}
                required
              />
            </Form.Group>
          </div>
          <hr style={{ height: '1px' }} />

          <Row className="mb-3">
           <Form.Group as={Col} xs={12} sm={6}>
              <Form.Label className='labelText'>Mobile (WhatsApp) Number</Form.Label>
              <Form.Control
                id="mobileNumber"
                type="text" // keep text to fully control input
                placeholder=""
                value={mob_no}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) { // allow only digits
                    setmob_no(value);
                  }
                }}
                required
              />
              {errors.mob_no && <p className="text-danger">{errors.mob_no}</p>}
            </Form.Group>


            <Form.Group as={Col} xs={12} sm={6}>
              <Form.Label className='labelText'>Alternate Number</Form.Label>
              <Form.Control
                id="alternateNumber"
                type="text"
                placeholder=""
                value={alternate_mobno}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {  // only digits allowed
                    setalternate_mobno(value);
                  }
                }}
              />
              {errors.alternate_mobno && (
                <p className="text-danger">{errors.alternate_mobno}</p>
              )}
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
              <Form.Label className='labelText'>Qualification</Form.Label>
              <Form.Control
                type="text"
                placeholder=""
                maxLength={200}
                value={qualification}
                onChange={(e) => setqualification(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={6} controlId="formGridState">
              <Form.Label className='labelText'>Professional Category</Form.Label>
              <Form.Select
                defaultValue="Choose..."
                value={professional_category}
                onChange={(e) => setprofessional_category(e.target.value)}
                required
              >
                <option>Choose...</option>
                <option value="Teacher/Professor">Teacher/Professor</option>
                <option value="Chef">Chef</option>
                <option value="Engineer">Engineer</option>
                <option value="Software IT">Software IT</option>
                <option value="Lawyer">Lawyer</option>
                <option value="Chartered Accountant">
                  Chartered Accountant
                </option>
                <option value="Aviator">Aviator</option>
                <option value="Health professional">Health professional</option>
                <option value="Architect">Architect</option>
                <option value="Analyst">Analyst</option>
                <option value="Data Engineer">Data Engineer</option>
                <option value="Makeup Artist">Makeup Artist</option>
                <option value="Medical Representative">
                  Medical Representative
                </option>
                <option value="Flight Attendant">Flight Attendant</option>
                <option value="Customer Service Representative">
                  Customer Service Representative
                </option>
                <option value="Network Administrator">
                  Network Administrator
                </option>
                <option value="Accountant">Accountant</option>
                <option value="Physician">Physician</option>
                <option value="Secretary">Secretary</option>
                <option value="Dentist">Dentist</option>
                <option value="Designer">Designer</option>
                <option value="Economist">Economist</option>
                <option value="Dietitians And Nutritionists">
                  Dietitians And Nutritionists
                </option>
                <option value="Air Traffic Controller">
                  Air Traffic Controller
                </option>
                <option value="Photographer">Photographer</option>
                <option value="Mechanic">Mechanic</option>
                <option value="Driver">Driver</option>
                <option value="Personal Stylist">Personal Stylist</option>
                <option value="Aeronautical Engineer">
                  Aeronautical Engineer
                </option>
                <option value="Business Consultant">Business Consultant</option>
                <option value="Software Engineer">Software Engineer</option>
                <option value="Data Scientist">Data Scientist</option>
                <option value="Advocate">Advocate</option>
                <option value="Veterinarian">Veterinarian</option>
                <option value="Businessperson">Businessperson</option>
                <option value="Web Designer">Web Designer</option>
                <option value="Scientist">Scientist</option>
                <option value="Firefighter">Firefighter</option>
                <option value="Journalist">Journalist</option>
                <option value="Politician">Politician</option>
                <option value="Farmer">Farmer</option>
                <option value="Judge">Judge</option>
                <option value="Civil Engineer">Civil Engineer</option>
                <option value="Technician">Technician</option>
                <option value="Design Engineer">Design Engineer</option>
                <option value="Private Investigator">
                  Private Investigator
                </option>
                <option value="Geologist">Geologist</option>
                <option value="Merchant">Merchant</option>
                <option value="Chemist">Chemist</option>
                <option value="Pharmasist">Pharmasist</option>
                <option value="Civil Contractor">Civil Contractor</option>
                <option value="Tax Consultant">Tax Consultant</option>
                <option value="Policeman">Policeman</option>
                <option value="Civil Administration">
                  Civil Administration
                </option>
                <option value="Govt. Service man">Govt. Service man</option>
                <option value="Student">Student</option>
                <option value="Defence Services">Defence Services</option>
                <option value="Electrician">Electrician</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} sm={6} controlId="formGridEmail">
              <Form.Label className='labelText'>
                Name & Address Of Business/Company/Employer
              </Form.Label>
              <Form.Control
                type="text"
                value={service_name}
                onChange={(e) => setservice_name(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} sm={6} controlId="formGridYearRange">
              <Form.Label className='labelText'>Year of Boarding Residence</Form.Label>
              <div className="d-flex">
                <Form.Select
                  value={yearFrom}
                  defaultValue="Choose..."
                  name="fromyear"
                  onChange={handleChangeFrom}
                  className="mr-5"
                  required
                >
                  {[...Array(50)].map((_, index) => (
                    <option key={index} value={currentYear - index}>
                      From ({currentYear - index})
                    </option>
                  ))}
                </Form.Select>
                <Form.Select
                  value={yearTo}
                  name="toyear"
                  defaultValue="Choose..."
                  onChange={handleChangeTo}
                  required
                >
                  {[...Array(50)].map((_, index) => (
                    <option key={index} value={currentYear - index}>
                      To ({currentYear - index})
                    </option>
                  ))}
                </Form.Select>
              </div>
            </Form.Group>
          </Row>
          <hr style={{ height: '1px' }} />

          <Row className="mb-3">
            <Form.Label style={{ color: 'gray' }}>
              Reference of other Partners with Contact details, If Any
            </Form.Label>
            <Form.Label className='labelText'>Partner's Full Name</Form.Label>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridEmail">
              <Form.Control
                type="text"
                placeholder="First Name"
                value={reference_fname}
                onChange={(e) => setreference_fname(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridEmail">
              <Form.Control
                type="text"
                placeholder="Middle Name"
                value={reference_mname}
                onChange={(e) => setreference_mname(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} xs={12} sm={4} controlId="formGridEmail">
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={reference_lname}
                onChange={(e) => setreference_lname(e.target.value)}
              />
            </Form.Group>
          </Row>
         <Form.Group as={Col} xs={12} sm={4} controlId="formGridEmail">
            <Form.Label className='labelText'>Partner's Contact</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={contactdetails}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {  // allow only numbers
                  setcontactdetails(value);
                }
              }}
            />
          </Form.Group>

          <hr style={{ height: '1px' }} />

          <Form.Group as={Col} xs={12} controlId="formGridEmail">
            <Form.Label className='labelText'>Special Achievements</Form.Label>
            <Form.Control
              type="text"
              placeholder=""
              value={achievements}
              onChange={(e) => setachievements(e.target.value)}
            />
          </Form.Group>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} controlId="formGridPassword">
              <Form.Label className="pt-2 labelText">Suggestions/Comments</Form.Label>
              <Form.Control
                type="textarea"
                placeholder="Leave a comment here"
                value={comment}
                onChange={(e) => setcomment(e.target.value)}
                className="w-100"
              />
            </Form.Group>
          </Row>

          <div className="text-center">
            {/* <Button
              variant="primary"
              onClick={handleSubmit}
              className="regbtn p-3"
              disabled={loading}
              style={{ backgroundColor: 'rgb(0, 120, 215)', color: 'white' }}
            >
              {loading ? (
                <ThreeDots
                  height="20"
                  width="30"
                  radius="9"
                  color="black"
                  ariaLabel="three-dots-loading"
                  visible={true}
                />
              ) : (
                'Register'
              )}
            </Button> */}

            <Button  onClick={handleSubmit}
                        variant="primary"
                        type="submit"
                        style={{
                          marginLeft: 'auto',
                          marginRight: 'auto',
                          display: 'block',
                          width: '140px',
                          fontSize: '15px',
                           backgroundColor: 'rgb(0, 120, 215)', color: 'white'
                        }}
                        className="regbtn"
                        disabled={loading} // disable when loading
                      >
                        {loading ? (
                          <>
                            <div
                              style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                width: '100vw',
                                height: '100vh',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)', // optional dim background
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                zIndex: 9999,
                              }}
                            >
                              <img
                                src={loadingImg}
                                alt="Loading..."
                                style={{
                                  width: '120px',
                                  height: '120px',
                                }}
                              />
                            </div>
                          </>
                        ) : (
                          'Register'
                        )}
                      </Button>

          </div>
        </div>
      </Container>
    </>
  )
}
export default Aluminiform
